import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { fetchClientLabels } from '../../../DisplayClientLabels'
import { modalActions, ModalTypes } from '../../../../entities/Modal'

export const deleteClientLabel = createAsyncThunk<
	void,
	string,
	ThunkConfig<string>
>(
	'deleteClientLabel',
	async (clientLabelId, thunkAPI) => {
		const { dispatch, extra: { api }, rejectWithValue } = thunkAPI

		try {
			await api.delete(`/clientLabels/${clientLabelId}`)

			showToast({
				type: 'success',
				toastId: 'deleteClientLabel',
				message: 'Success'
			})

			dispatch(fetchClientLabels())
		} catch (e: any) {
			console.log(e)
			if (e?.response.status === 409) {
				dispatch(modalActions.showModal({
					modalType: ModalTypes.SHOW_409_MODAL,
					data: e?.response.data.message
				}))
			} else {
				appHandleError(e, 'deleteClientLabel', 'Failed to delete client label')
			}
			return rejectWithValue('Error occurred on client label delete')
		}
	})